/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { APIException } from '../model';
// @ts-ignore
import { EmailCodeRequest } from '../model';
// @ts-ignore
import { MobileCodeRequest } from '../model';
// @ts-ignore
import { RegisteredUser } from '../model';
// @ts-ignore
import { UserRegisterBuyerRequest } from '../model';
// @ts-ignore
import { UserRegisterSellerRequest } from '../model';
// @ts-ignore
import { ValidationError } from '../model';
/**
 * UserRegisterApi - axios parameter creator
 * @export
 */
export const UserRegisterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * The seller is first created and a verification Email and SMS is sent out
         * @summary Register a seller
         * @param {UserRegisterSellerRequest} userRegisterSellerRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerRegisterCreate: async (userRegisterSellerRequest: UserRegisterSellerRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userRegisterSellerRequest' is not null or undefined
            assertParamExists('sellerRegisterCreate', 'userRegisterSellerRequest', userRegisterSellerRequest)
            const localVarPath = `/v2/seller/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userRegisterSellerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validates the user has received the email by validating the database record against the code sent
         * @summary Validates a users email address
         * @param {EmailCodeRequest} emailCodeRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerValidateEmailCreate: async (emailCodeRequest: EmailCodeRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailCodeRequest' is not null or undefined
            assertParamExists('sellerValidateEmailCreate', 'emailCodeRequest', emailCodeRequest)
            const localVarPath = `/v2/seller/validate/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sends out a new code, making any previous ones sent out invalid
         * @summary Resends out a verification code to the users email
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerValidateEmailResendCreate: async (aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/seller/validate/email/resend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validates the users mobile number by validating the code being entered matches that of the latest one assigned to the user.  If a newer code has been sent out after the code being used, an expired code error will be returned
         * @summary Validates a users mobile number
         * @param {MobileCodeRequest} mobileCodeRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerValidateMobileCreate: async (mobileCodeRequest: MobileCodeRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'mobileCodeRequest' is not null or undefined
            assertParamExists('sellerValidateMobileCreate', 'mobileCodeRequest', mobileCodeRequest)
            const localVarPath = `/v2/seller/validate/mobile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mobileCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sends out a new code, making any previous ones sent out invalid
         * @summary Re-sends out a verification code to the users mobile
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerValidateMobileResendCreate: async (aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/seller/validate/mobile/resend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The buyer is first created and a verification email is then sent out
         * @summary Register a buyer
         * @param {UserRegisterBuyerRequest} userRegisterBuyerRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegisterCreate: async (userRegisterBuyerRequest: UserRegisterBuyerRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userRegisterBuyerRequest' is not null or undefined
            assertParamExists('userRegisterCreate', 'userRegisterBuyerRequest', userRegisterBuyerRequest)
            const localVarPath = `/v2/user/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userRegisterBuyerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validates the user has received the email by validating the database record against the code sent
         * @summary Validates a users email address
         * @param {EmailCodeRequest} emailCodeRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegisterValidateEmailCreate: async (emailCodeRequest: EmailCodeRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailCodeRequest' is not null or undefined
            assertParamExists('userRegisterValidateEmailCreate', 'emailCodeRequest', emailCodeRequest)
            const localVarPath = `/v2/user/register/validate/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sends out a new code, making any previous ones sent out invalid
         * @summary Resends out a verification code to the users email
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegisterValidateEmailResendCreate: async (aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/user/register/validate/email/resend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validates the users mobile number by validating the code being entered matches that of the latest one assigned to the user.  If a newer code has been sent out after the code being used, an expired code error will be returned
         * @summary Validates a users mobile number
         * @param {MobileCodeRequest} mobileCodeRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegisterValidateMobileCreate: async (mobileCodeRequest: MobileCodeRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'mobileCodeRequest' is not null or undefined
            assertParamExists('userRegisterValidateMobileCreate', 'mobileCodeRequest', mobileCodeRequest)
            const localVarPath = `/v2/user/register/validate/mobile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mobileCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sends out a new code, making any previous ones sent out invalid
         * @summary Re-sends out a verification code to the users mobile
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegisterValidateMobileResendCreate: async (aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/user/register/validate/mobile/resend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserRegisterApi - functional programming interface
 * @export
 */
export const UserRegisterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserRegisterApiAxiosParamCreator(configuration)
    return {
        /**
         * The seller is first created and a verification Email and SMS is sent out
         * @summary Register a seller
         * @param {UserRegisterSellerRequest} userRegisterSellerRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sellerRegisterCreate(userRegisterSellerRequest: UserRegisterSellerRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisteredUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sellerRegisterCreate(userRegisterSellerRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Validates the user has received the email by validating the database record against the code sent
         * @summary Validates a users email address
         * @param {EmailCodeRequest} emailCodeRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sellerValidateEmailCreate(emailCodeRequest: EmailCodeRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sellerValidateEmailCreate(emailCodeRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sends out a new code, making any previous ones sent out invalid
         * @summary Resends out a verification code to the users email
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sellerValidateEmailResendCreate(aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sellerValidateEmailResendCreate(aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Validates the users mobile number by validating the code being entered matches that of the latest one assigned to the user.  If a newer code has been sent out after the code being used, an expired code error will be returned
         * @summary Validates a users mobile number
         * @param {MobileCodeRequest} mobileCodeRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sellerValidateMobileCreate(mobileCodeRequest: MobileCodeRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sellerValidateMobileCreate(mobileCodeRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sends out a new code, making any previous ones sent out invalid
         * @summary Re-sends out a verification code to the users mobile
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sellerValidateMobileResendCreate(aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sellerValidateMobileResendCreate(aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The buyer is first created and a verification email is then sent out
         * @summary Register a buyer
         * @param {UserRegisterBuyerRequest} userRegisterBuyerRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userRegisterCreate(userRegisterBuyerRequest: UserRegisterBuyerRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisteredUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userRegisterCreate(userRegisterBuyerRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Validates the user has received the email by validating the database record against the code sent
         * @summary Validates a users email address
         * @param {EmailCodeRequest} emailCodeRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userRegisterValidateEmailCreate(emailCodeRequest: EmailCodeRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userRegisterValidateEmailCreate(emailCodeRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sends out a new code, making any previous ones sent out invalid
         * @summary Resends out a verification code to the users email
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userRegisterValidateEmailResendCreate(aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userRegisterValidateEmailResendCreate(aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Validates the users mobile number by validating the code being entered matches that of the latest one assigned to the user.  If a newer code has been sent out after the code being used, an expired code error will be returned
         * @summary Validates a users mobile number
         * @param {MobileCodeRequest} mobileCodeRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userRegisterValidateMobileCreate(mobileCodeRequest: MobileCodeRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userRegisterValidateMobileCreate(mobileCodeRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sends out a new code, making any previous ones sent out invalid
         * @summary Re-sends out a verification code to the users mobile
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userRegisterValidateMobileResendCreate(aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userRegisterValidateMobileResendCreate(aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserRegisterApi - factory interface
 * @export
 */
export const UserRegisterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserRegisterApiFp(configuration)
    return {
        /**
         * The seller is first created and a verification Email and SMS is sent out
         * @summary Register a seller
         * @param {UserRegisterSellerRequest} userRegisterSellerRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerRegisterCreate(userRegisterSellerRequest: UserRegisterSellerRequest, aaSource?: string, options?: any): AxiosPromise<RegisteredUser> {
            return localVarFp.sellerRegisterCreate(userRegisterSellerRequest, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Validates the user has received the email by validating the database record against the code sent
         * @summary Validates a users email address
         * @param {EmailCodeRequest} emailCodeRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerValidateEmailCreate(emailCodeRequest: EmailCodeRequest, aaSource?: string, options?: any): AxiosPromise<string> {
            return localVarFp.sellerValidateEmailCreate(emailCodeRequest, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Sends out a new code, making any previous ones sent out invalid
         * @summary Resends out a verification code to the users email
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerValidateEmailResendCreate(aaSource?: string, options?: any): AxiosPromise<void> {
            return localVarFp.sellerValidateEmailResendCreate(aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Validates the users mobile number by validating the code being entered matches that of the latest one assigned to the user.  If a newer code has been sent out after the code being used, an expired code error will be returned
         * @summary Validates a users mobile number
         * @param {MobileCodeRequest} mobileCodeRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerValidateMobileCreate(mobileCodeRequest: MobileCodeRequest, aaSource?: string, options?: any): AxiosPromise<void> {
            return localVarFp.sellerValidateMobileCreate(mobileCodeRequest, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Sends out a new code, making any previous ones sent out invalid
         * @summary Re-sends out a verification code to the users mobile
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerValidateMobileResendCreate(aaSource?: string, options?: any): AxiosPromise<void> {
            return localVarFp.sellerValidateMobileResendCreate(aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * The buyer is first created and a verification email is then sent out
         * @summary Register a buyer
         * @param {UserRegisterBuyerRequest} userRegisterBuyerRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegisterCreate(userRegisterBuyerRequest: UserRegisterBuyerRequest, aaSource?: string, options?: any): AxiosPromise<RegisteredUser> {
            return localVarFp.userRegisterCreate(userRegisterBuyerRequest, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Validates the user has received the email by validating the database record against the code sent
         * @summary Validates a users email address
         * @param {EmailCodeRequest} emailCodeRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegisterValidateEmailCreate(emailCodeRequest: EmailCodeRequest, aaSource?: string, options?: any): AxiosPromise<string> {
            return localVarFp.userRegisterValidateEmailCreate(emailCodeRequest, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Sends out a new code, making any previous ones sent out invalid
         * @summary Resends out a verification code to the users email
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegisterValidateEmailResendCreate(aaSource?: string, options?: any): AxiosPromise<void> {
            return localVarFp.userRegisterValidateEmailResendCreate(aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Validates the users mobile number by validating the code being entered matches that of the latest one assigned to the user.  If a newer code has been sent out after the code being used, an expired code error will be returned
         * @summary Validates a users mobile number
         * @param {MobileCodeRequest} mobileCodeRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegisterValidateMobileCreate(mobileCodeRequest: MobileCodeRequest, aaSource?: string, options?: any): AxiosPromise<void> {
            return localVarFp.userRegisterValidateMobileCreate(mobileCodeRequest, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Sends out a new code, making any previous ones sent out invalid
         * @summary Re-sends out a verification code to the users mobile
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegisterValidateMobileResendCreate(aaSource?: string, options?: any): AxiosPromise<void> {
            return localVarFp.userRegisterValidateMobileResendCreate(aaSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for sellerRegisterCreate operation in UserRegisterApi.
 * @export
 * @interface UserRegisterApiSellerRegisterCreateRequest
 */
export interface UserRegisterApiSellerRegisterCreateRequest {
    /**
     * 
     * @type {UserRegisterSellerRequest}
     * @memberof UserRegisterApiSellerRegisterCreate
     */
    readonly userRegisterSellerRequest: UserRegisterSellerRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof UserRegisterApiSellerRegisterCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for sellerValidateEmailCreate operation in UserRegisterApi.
 * @export
 * @interface UserRegisterApiSellerValidateEmailCreateRequest
 */
export interface UserRegisterApiSellerValidateEmailCreateRequest {
    /**
     * 
     * @type {EmailCodeRequest}
     * @memberof UserRegisterApiSellerValidateEmailCreate
     */
    readonly emailCodeRequest: EmailCodeRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof UserRegisterApiSellerValidateEmailCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for sellerValidateEmailResendCreate operation in UserRegisterApi.
 * @export
 * @interface UserRegisterApiSellerValidateEmailResendCreateRequest
 */
export interface UserRegisterApiSellerValidateEmailResendCreateRequest {
    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof UserRegisterApiSellerValidateEmailResendCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for sellerValidateMobileCreate operation in UserRegisterApi.
 * @export
 * @interface UserRegisterApiSellerValidateMobileCreateRequest
 */
export interface UserRegisterApiSellerValidateMobileCreateRequest {
    /**
     * 
     * @type {MobileCodeRequest}
     * @memberof UserRegisterApiSellerValidateMobileCreate
     */
    readonly mobileCodeRequest: MobileCodeRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof UserRegisterApiSellerValidateMobileCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for sellerValidateMobileResendCreate operation in UserRegisterApi.
 * @export
 * @interface UserRegisterApiSellerValidateMobileResendCreateRequest
 */
export interface UserRegisterApiSellerValidateMobileResendCreateRequest {
    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof UserRegisterApiSellerValidateMobileResendCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for userRegisterCreate operation in UserRegisterApi.
 * @export
 * @interface UserRegisterApiUserRegisterCreateRequest
 */
export interface UserRegisterApiUserRegisterCreateRequest {
    /**
     * 
     * @type {UserRegisterBuyerRequest}
     * @memberof UserRegisterApiUserRegisterCreate
     */
    readonly userRegisterBuyerRequest: UserRegisterBuyerRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof UserRegisterApiUserRegisterCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for userRegisterValidateEmailCreate operation in UserRegisterApi.
 * @export
 * @interface UserRegisterApiUserRegisterValidateEmailCreateRequest
 */
export interface UserRegisterApiUserRegisterValidateEmailCreateRequest {
    /**
     * 
     * @type {EmailCodeRequest}
     * @memberof UserRegisterApiUserRegisterValidateEmailCreate
     */
    readonly emailCodeRequest: EmailCodeRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof UserRegisterApiUserRegisterValidateEmailCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for userRegisterValidateEmailResendCreate operation in UserRegisterApi.
 * @export
 * @interface UserRegisterApiUserRegisterValidateEmailResendCreateRequest
 */
export interface UserRegisterApiUserRegisterValidateEmailResendCreateRequest {
    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof UserRegisterApiUserRegisterValidateEmailResendCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for userRegisterValidateMobileCreate operation in UserRegisterApi.
 * @export
 * @interface UserRegisterApiUserRegisterValidateMobileCreateRequest
 */
export interface UserRegisterApiUserRegisterValidateMobileCreateRequest {
    /**
     * 
     * @type {MobileCodeRequest}
     * @memberof UserRegisterApiUserRegisterValidateMobileCreate
     */
    readonly mobileCodeRequest: MobileCodeRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof UserRegisterApiUserRegisterValidateMobileCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for userRegisterValidateMobileResendCreate operation in UserRegisterApi.
 * @export
 * @interface UserRegisterApiUserRegisterValidateMobileResendCreateRequest
 */
export interface UserRegisterApiUserRegisterValidateMobileResendCreateRequest {
    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof UserRegisterApiUserRegisterValidateMobileResendCreate
     */
    readonly aaSource?: string
}

/**
 * UserRegisterApi - object-oriented interface
 * @export
 * @class UserRegisterApi
 * @extends {BaseAPI}
 */
export class UserRegisterApi extends BaseAPI {
    /**
     * The seller is first created and a verification Email and SMS is sent out
     * @summary Register a seller
     * @param {UserRegisterApiSellerRegisterCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRegisterApi
     */
    public sellerRegisterCreate(requestParameters: UserRegisterApiSellerRegisterCreateRequest, options?: any) {
        return UserRegisterApiFp(this.configuration).sellerRegisterCreate(requestParameters.userRegisterSellerRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validates the user has received the email by validating the database record against the code sent
     * @summary Validates a users email address
     * @param {UserRegisterApiSellerValidateEmailCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRegisterApi
     */
    public sellerValidateEmailCreate(requestParameters: UserRegisterApiSellerValidateEmailCreateRequest, options?: any) {
        return UserRegisterApiFp(this.configuration).sellerValidateEmailCreate(requestParameters.emailCodeRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sends out a new code, making any previous ones sent out invalid
     * @summary Resends out a verification code to the users email
     * @param {UserRegisterApiSellerValidateEmailResendCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRegisterApi
     */
    public sellerValidateEmailResendCreate(requestParameters: UserRegisterApiSellerValidateEmailResendCreateRequest = {}, options?: any) {
        return UserRegisterApiFp(this.configuration).sellerValidateEmailResendCreate(requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validates the users mobile number by validating the code being entered matches that of the latest one assigned to the user.  If a newer code has been sent out after the code being used, an expired code error will be returned
     * @summary Validates a users mobile number
     * @param {UserRegisterApiSellerValidateMobileCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRegisterApi
     */
    public sellerValidateMobileCreate(requestParameters: UserRegisterApiSellerValidateMobileCreateRequest, options?: any) {
        return UserRegisterApiFp(this.configuration).sellerValidateMobileCreate(requestParameters.mobileCodeRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sends out a new code, making any previous ones sent out invalid
     * @summary Re-sends out a verification code to the users mobile
     * @param {UserRegisterApiSellerValidateMobileResendCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRegisterApi
     */
    public sellerValidateMobileResendCreate(requestParameters: UserRegisterApiSellerValidateMobileResendCreateRequest = {}, options?: any) {
        return UserRegisterApiFp(this.configuration).sellerValidateMobileResendCreate(requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The buyer is first created and a verification email is then sent out
     * @summary Register a buyer
     * @param {UserRegisterApiUserRegisterCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRegisterApi
     */
    public userRegisterCreate(requestParameters: UserRegisterApiUserRegisterCreateRequest, options?: any) {
        return UserRegisterApiFp(this.configuration).userRegisterCreate(requestParameters.userRegisterBuyerRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validates the user has received the email by validating the database record against the code sent
     * @summary Validates a users email address
     * @param {UserRegisterApiUserRegisterValidateEmailCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRegisterApi
     */
    public userRegisterValidateEmailCreate(requestParameters: UserRegisterApiUserRegisterValidateEmailCreateRequest, options?: any) {
        return UserRegisterApiFp(this.configuration).userRegisterValidateEmailCreate(requestParameters.emailCodeRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sends out a new code, making any previous ones sent out invalid
     * @summary Resends out a verification code to the users email
     * @param {UserRegisterApiUserRegisterValidateEmailResendCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRegisterApi
     */
    public userRegisterValidateEmailResendCreate(requestParameters: UserRegisterApiUserRegisterValidateEmailResendCreateRequest = {}, options?: any) {
        return UserRegisterApiFp(this.configuration).userRegisterValidateEmailResendCreate(requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validates the users mobile number by validating the code being entered matches that of the latest one assigned to the user.  If a newer code has been sent out after the code being used, an expired code error will be returned
     * @summary Validates a users mobile number
     * @param {UserRegisterApiUserRegisterValidateMobileCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRegisterApi
     */
    public userRegisterValidateMobileCreate(requestParameters: UserRegisterApiUserRegisterValidateMobileCreateRequest, options?: any) {
        return UserRegisterApiFp(this.configuration).userRegisterValidateMobileCreate(requestParameters.mobileCodeRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sends out a new code, making any previous ones sent out invalid
     * @summary Re-sends out a verification code to the users mobile
     * @param {UserRegisterApiUserRegisterValidateMobileResendCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRegisterApi
     */
    public userRegisterValidateMobileResendCreate(requestParameters: UserRegisterApiUserRegisterValidateMobileResendCreateRequest = {}, options?: any) {
        return UserRegisterApiFp(this.configuration).userRegisterValidateMobileResendCreate(requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }
}
